import { Id } from "@planzone/dto";

type WbsMeta = {
  [key: string]: {
    allocatedHours: number;
    attachmentCount: number;
    commentCount: number;
    elementCount: number;
    duration: number;
    percentComplete: number;
    spentHours: number;
    uuid: Id;
  };
};

const wbsMeta: WbsMeta = {};

export type { WbsMeta };

export { wbsMeta };
